import { FilterExpr } from './wire';

/**
 * `left AND right`. Top-level ANDs are spliced so repeated additions stay one flat list; an OR or a
 * negation is kept as one operand, because splicing its children into the AND would change what it
 * matches.
 */
export function andFilters(
  left: FilterExpr | undefined,
  right: FilterExpr | undefined
): FilterExpr | undefined {
  const items = [...andOperands(left), ...andOperands(right)];
  if (items.length === 0) return undefined;
  return items.length === 1 ? items[0] : { and: items };
}

function andOperands(expr: FilterExpr | undefined): FilterExpr[] {
  if (expr === undefined) return [];
  return 'and' in expr ? expr.and : [expr];
}
